import {Power0} from 'gsap';
import {animatinGears} from '../rotateGears';

const scheme = document.querySelector('.chapter__scheme.scheme-3-1 svg');

const resetNav = () => {
	const nav = scheme.querySelector('.nav');
	const strok = scheme.querySelectorAll('.strok');
	const dot = nav.querySelectorAll('.nav__dot');
	const lines = scheme.querySelectorAll('.nav__line-main, .nav__line, .progress-bar');

	gsap.set([dot, strok], {
		alpha: 0,
	});

	lines.forEach((element) => {
		const path = element.getTotalLength();

		gsap.set(element, {
			strokeDashoffset: path,
			strokeDasharray: `${path}, ${path}`,
		});
	});
};

const reset = () => {
	resetNav();
};

reset();

const showstrok = () => {
	const group = scheme.querySelectorAll('.stroks-group');
	let cnt = 0;

	group.forEach((element) => {
		const tm = gsap.timeline();
		const strok = element.querySelectorAll('.strok');

		tm.to(strok, {
			onComplete() {
				setTimeout(() => {
					tm.reverse();
				}, 2000);
			},
			onReverseComplete() {
				tm.play();
			},
			duration: 0.5,
			stagger: 0.2,
			ease: Power0.easeInOut,
			alpha: 1,
			y: 0,
		}, cnt);

		cnt += 2;
	});
};

const startAnimeProgressLine = (node) => {
	const parent = node.querySelectorAll('.progress-lines');

	parent.forEach((element) => {
		const status = element.querySelectorAll('.progress-bar');
		const progress = element.querySelectorAll('.progress');
		const tmProgress = gsap.timeline({paused: true});
		const tm = gsap.timeline({paused: true});

		if (progress.length === 0) {
			return;
		}

		tmProgress.to(progress, {
			onStart() {
				tm.play();
			},
			onReverseComplete() {
				tmProgress.play();
			},
			duration: 0.35,
			ease: Power0.easeInOut,
			stroke: '#2796EE',
		});

		if (status.length) {
			tm.to(status, {
				onComplete() {
					tm.reverse();
				},
				onReverseComplete() {
					tmProgress.reverse();
				},
				duration: 3.5,
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
			}, 0.2);
		}

		tmProgress.play();
	});
};

const showDot = (dot) => {
	const tl = gsap.timeline({paused: true});

	return (
		tl.to(dot, {
			duration: 0.35,
			alpha: 1,
		})
	);
};

const startNav = () => {
	const main = scheme.querySelector('.nav-group--main');
	const dotFirst = main.querySelector('.nav__dot--first');
	const dotLast = main.querySelector('.nav__dot--last');
	const lineFirst = document.querySelector('.nav-group.nav-group--2 .nav__line');
	const lineLast = document.querySelector('.nav-group.nav-group--3 .nav__line');
	const lineMain = main.querySelector('.nav__line-main');
	const tlMain = gsap.timeline({paused: true});

	tlMain
		.to(lineMain, {
			onStart() {
				const firstDots = showDot(dotFirst);

				firstDots.play();
			},
			onComplete() {
				const lasttDots = showDot(dotLast);

				lasttDots.play();
			},
			duration: 3.5,
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			alpha: 1,
		})
		.to(lineFirst, {
			onComplete() {
				const dots = document.querySelector('.nav-group.nav-group--2 .nav__dot');
				const firstDots = showDot(dots);

				firstDots.play();
			},
			duration: 0.5,
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			alpha: 1,
		}, 1.625)
		.to(lineLast, {
			onComplete() {
				const dots = document.querySelector('.nav-group.nav-group--3 .nav__dot');
				const firstDots = showDot(dots);

				firstDots.play();
			},
			duration: 0.5,
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			alpha: 1,
		}, 2.360)
		.play();
};

const initAnimationPartThree = () => {
	startNav();
	showstrok(scheme);
	animatinGears(scheme);
	startAnimeProgressLine(scheme);
};

export {initAnimationPartThree};

